export default "__VITE_ASSET__BkbAIe7B__"